module.exports = __webpack_public_path__ + "img/gfl.95113d5f.png";